package com.milta.core.mode

import kotlinx.browser.localStorage

/** Kotlin/JS implementation of [AppModeStorage] — browser `localStorage`. */
class JsAppModeStorage : AppModeStorage {
    override fun getMode(): String? = localStorage.getItem(KEY_MODE)
    override fun saveMode(mode: String) { localStorage.setItem(KEY_MODE, mode) }
    override fun clear() { localStorage.removeItem(KEY_MODE) }

    private companion object {
        const val KEY_MODE = "milta_app_mode"
    }
}
